import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';

import { usersAPI } from 'services/apiRest';
import CollabsActions from '../ducks/collaborators';

export function* getCollabs() {
  try {
    // Removido filtro por role (campo descontinuado) - buscar todos os usuários
    const users = yield call(usersAPI.listar, {});

    // Converter formato de data se necessário
    const usersFormatted = users.map((user) => ({
      ...user,
      created_at: user.created_at
        ? typeof user.created_at === 'string'
          ? { seconds: Math.round(new Date(user.created_at).getTime() / 1000) }
          : user.created_at
        : { seconds: Math.round(Date.now() / 1000) },
    }));

    yield put(CollabsActions.getCollabsSuccess(usersFormatted));
  } catch (err) {
    console.error('❌ [collaborators saga] Erro ao buscar colaboradores:', err);
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao buscar colaboradores',
        message: err.message || 'Tente novamente',
      })
    );
    yield put(CollabsActions.getCollabsFailure(err));
  }
}

export function* getCollab({ id }) {
  try {
    const user = yield call(usersAPI.buscarPorId, id);

    // Converter formato de data se necessário
    const userFormatted = {
      ...user,
      created_at: user.created_at
        ? typeof user.created_at === 'string'
          ? { seconds: Math.round(new Date(user.created_at).getTime() / 1000) }
          : user.created_at
        : { seconds: Math.round(Date.now() / 1000) },
    };

    yield put(CollabsActions.getCollabSuccess(userFormatted));
  } catch (err) {
    console.error('❌ [collaborators saga] Erro ao buscar colaborador:', err);
    yield put(CollabsActions.getCollabFailure(err));
  }
}

export function* addCollab({ collab, closeModal }) {
  try {
    const { name, email, password, profile_id, avatar } = collab;

    // Preparar dados para envio
    // Removido role (campo descontinuado)
    const dadosUsuario = {
      name,
      email,
      password,
      profile_id: profile_id || null,
      status: 1,
    };

    // TODO: Upload de avatar se necessário (implementar endpoint separado)
    // Por enquanto, avatar será tratado separadamente se necessário

    const novoUsuario = yield call(usersAPI.criar, dadosUsuario);

    // Formatar data para compatibilidade
    const usuarioFormatado = {
      ...novoUsuario,
      created_at: novoUsuario.created_at
        ? typeof novoUsuario.created_at === 'string'
          ? { seconds: Math.round(new Date(novoUsuario.created_at).getTime() / 1000) }
          : novoUsuario.created_at
        : { seconds: Math.round(Date.now() / 1000) },
    };

    yield put(CollabsActions.addCollabSuccess(usuarioFormatado));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Sucesso',
        message: 'Colaborador criado com sucesso!',
      })
    );
    if (closeModal) closeModal();
  } catch (err) {
    console.error('❌ [collaborators saga] Erro ao criar colaborador:', err);
    
    let mensagem = 'Erro ao criar colaborador. Tente novamente.';
    if (err.message && err.message.includes('já cadastrado')) {
      mensagem = 'E-mail já cadastrado';
    }

    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao cadastrar',
        message: mensagem,
      })
    );

    yield put(CollabsActions.addCollabFailure(err));
  }
}

export function* updateCollab({ collab, closeModal }) {
  try {
    const { id, name, email, password, profile_id, avatar } = collab;

    // Log para debug
    console.log('🔍 [collaborators saga] Dados recebidos para atualização:', {
      id,
      name,
      email,
      profile_id,
      profile_id_type: typeof profile_id,
    });

    // Preparar dados para atualização
    const dadosAtualizacao = {
      name,
      email,
      profile_id: profile_id || null, // Garantir que seja null se não fornecido
    };

    // Log dos dados preparados
    console.log('📤 [collaborators saga] Dados a serem enviados:', dadosAtualizacao);

    // Incluir senha apenas se fornecida
    if (password && password.trim() !== '') {
      dadosAtualizacao.password = password;
    }

    // TODO: Upload de avatar se necessário (implementar endpoint separado)
    // Por enquanto, avatar será tratado separadamente se necessário

    const usuarioAtualizado = yield call(usersAPI.atualizar, id, dadosAtualizacao);

    // Log do resultado
    console.log('✅ [collaborators saga] Usuário atualizado:', {
      id: usuarioAtualizado.id,
      email: usuarioAtualizado.email,
      profile_id: usuarioAtualizado.profile_id,
    });

    // Formatar data para compatibilidade
    const usuarioFormatado = {
      ...usuarioAtualizado,
      created_at: usuarioAtualizado.created_at
        ? typeof usuarioAtualizado.created_at === 'string'
          ? { seconds: Math.round(new Date(usuarioAtualizado.created_at).getTime() / 1000) }
          : usuarioAtualizado.created_at
        : { seconds: Math.round(Date.now() / 1000) },
    };

    yield put(CollabsActions.updateCollabSuccess(usuarioFormatado));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Sucesso',
        message: 'Colaborador atualizado com sucesso!',
      })
    );
    if (closeModal) closeModal();
  } catch (err) {
    console.error('❌ [collaborators saga] Erro ao atualizar colaborador:', err);
    
    let mensagem = 'Erro ao atualizar colaborador. Tente novamente.';
    if (err.message && err.message.includes('já está em uso')) {
      mensagem = 'E-mail já está em uso por outro usuário';
    }

    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao atualizar',
        message: mensagem,
      })
    );

    yield put(CollabsActions.updateCollabFailure(err));
  }
}

export function* reactivateCollab({ email, closeModal }) {
  try {
    const usuarioReativado = yield call(usersAPI.reativar, email);

    yield put(CollabsActions.reactivateCollabSuccess());
    yield put(CollabsActions.getCollabsRequest());
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Sucesso',
        message: 'Usuário reativado com sucesso!',
      })
    );

    if (closeModal) closeModal();
  } catch (err) {
    console.error('❌ [collaborators saga] Erro ao reativar colaborador:', err);
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao reativar usuário',
        message: err.message || 'Tente novamente',
      })
    );
    yield put(CollabsActions.reactivateCollabFailure(err));
  }
}

export function* removeCollab({ id }) {
  try {
    yield call(usersAPI.deletar, id);

    yield put(CollabsActions.removeCollabSuccess());
    yield put(CollabsActions.getCollabsRequest());
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Sucesso',
        message: 'Colaborador desativado com sucesso!',
      })
    );
  } catch (err) {
    console.error('❌ [collaborators saga] Erro ao remover colaborador:', err);
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao desativar',
        message: err.message || 'Tente novamente',
      })
    );
    yield put(CollabsActions.removeCollabFailure(err));
  }
}
